import React, { startTransition, useContext, useEffect, useState } from 'react'
import style from './OnionOption.module.scss'
import { getTranslation, Language } from '../../language'
import axios from 'axios'
import { Btn } from '../../c_ui/Btn'
// import { DeleteBtn } from '../../c_ui/DeleteBtn'
import { Input } from '../../c_ui/Input/Input'
import autorizationAnalizer from '../../service/functions/autorizationAnalizer'
import { useNavigate } from 'react-router-dom'
import { Loader } from '../Loader'
import { CustomAlert } from '../CustomAlert'
import { DeleteBtn } from '../../c_ui/DeleteBtn'
// import { RefreshBtn } from '../../c_ui/RefreshBtn'
import { PauseBtn } from '../../c_ui/PauseBtn'
import { UnpauseBtn } from '../../c_ui/UnpauseBtn'
import { RetryBtn } from '../../c_ui/RetryBtn/RetryBtn'
import { DownloadBtn } from '../../c_ui/DownloadBtn'
import { UploadProgressModal } from '../UploadProgressModal'
import { IgnoreIcon } from '../../c_ui/IgnoreIcon'

const BASE_URL = process.env.REACT_APP_BASE_URL

export const OnionOption = () => {
	const lang = useContext(Language)
	const TEXT = getTranslation(lang)
	const navigate = useNavigate()
	const [url, setUrl] = useState('')
	const [isLoader, setIsLoader] = useState(false)
	const [alertText, setAlertText] = useState('')
	const [files, setFiles] = useState([])

	const loadData = async () => {
		try {
			const res = await axios.post(
				`${BASE_URL}/getTorDownloads`,
				{
					// status: 'active', // можеш передавати completed/error
					limit: 100,
				},
				{ headers: { 'Content-Type': 'application/json' } }
			)
			setFiles(res.data.items || [])
			// console.log(res.data.items)
		} catch (err) {
			console.error('Load error:', err)
		}
	}

	useEffect(() => {
		loadData()

		const autorizationData = autorizationAnalizer()
		if (!autorizationData) {
			startTransition(() => {
				navigate('/')
			})
		}

		const interval = setInterval(() => {
			loadData()
		}, 10000)

		// очищення інтервалу
		return () => clearInterval(interval)
	}, [])

	const handleAddURL = async event => {
		event.preventDefault()

		if (!url.length) {
			setAlertText(TEXT.resource_is_required)
			return
		} else {
			setIsLoader(true)

			if (url.trim()) {
				try {
					const date = new Date().toLocaleDateString()
					await axios.post(
						`${BASE_URL}/uploadTorFile`,
						{ url, date },
						{ headers: { 'Content-Type': 'application/json' } }
					)

					setUrl('')
					loadData()
				} catch (error) {
					console.log('addResource error', error)
				} finally {
					setIsLoader(false)
				}
			}
		}
	}

	const handlePause = async gid => {
		// console.log(gid)
		try {
			await axios.post(
				`${BASE_URL}/pauseTorDownload`,
				{ gid },
				{
					headers: { 'Content-Type': 'application/json' },
				}
			)
			loadData()
		} catch (err) {
			console.error('pauseTorDownload error:', err)
		}
	}

	const handleUnpause = async gid => {
		// console.log(gid)
		try {
			await axios.post(
				`${BASE_URL}/unpauseTorDownload`,
				{ gid },
				{
					headers: { 'Content-Type': 'application/json' },
				}
			)
			loadData()
		} catch (err) {
			console.error('unpauseTorDownload error:', err)
		}
	}

	const handleRetry = async fileId => {
		console.log(fileId)
		try {
			await axios.post(
				`${BASE_URL}/retryTorDownload`,
				{ fileId },
				{
					headers: { 'Content-Type': 'application/json' },
				}
			)
			loadData()
		} catch (err) {
			console.error('retryTorDownload error:', err)
		}
	}

	const handleRemoveFileInfo = async query => {
		// console.log(query)
		try {
			await axios.post(
				`${BASE_URL}/removeTorDownload`,
				{
					// fileId: query._id,
					gid: query.aria_gid,
				},
				{
					headers: { 'Content-Type': 'application/json' },
				}
			)

			// видалити файл з сервера
			await axios.post(`${BASE_URL}/deleteFile`, {
				_id: query._id,
				post_date: query.post_date,
				resource: query.resource,
				file_name: query.file_name,
			})

			// видалити aria файл з сервера .aria2
			await axios.post(`${BASE_URL}/deleteTorFile`, {
				post_date: query.post_date,
				resource: query.resource,
				aria_file_name: query.file_name + '.aria2',
			})

			loadData()
		} catch (err) {
			console.error('removeTorDownload error:', err)
		}
	}

	const [progress, setProgress] = useState([])
	const [isProgressing, setIsProgressing] = useState(false)

	const handleDownload = async data => {
		setIsProgressing(true)

		try {
			// Створення XMLHttpRequest для контролю прогресу завантаження
			const xhr = new XMLHttpRequest()

			xhr.open(
				'POST',
				`${BASE_URL}/downloadFile/${data.post_date}/${data.resource}/original/${data.file_name}`,
				true
			)

			xhr.responseType = 'blob'

			xhr.onprogress = event => {
				if (event.lengthComputable) {
					const progress = Math.round((event.loaded / event.total) * 100)
					setProgress([{ fileName: data.file_name, progress: progress }]) // Оновлюємо прогрес
				}
			}

			xhr.onload = async () => {
				if (xhr.status === 200) {
					const url = window.URL.createObjectURL(xhr.response)
					const link = document.createElement('a')
					link.href = url

					// запис імені файлу
					link.setAttribute('download', data.file_name)
					document.body.appendChild(link)
					link.click()
					document.body.removeChild(link)

					setIsProgressing(false)
					document.body.style.overflow = ''

					// if (!data.is_inspector_take_filtered) {
					// 	await axios.post(`${BASE_URL}/fileTake`, {
					// 		id: data._id,
					// 		role: 'inspector_filtered',
					// 	})
					// }
				}

				// setIsProgressing(false)
			}

			xhr.onerror = err => {
				console.error('Download failed:', err)
				setIsProgressing(false)
			}

			xhr.send()

			await axios.post(`${BASE_URL}/fileTake`, {
				id: data._id,
				role: 'inspector_original',
			})
		} catch (err) {
			console.log(err)
		}
	}

	return (
		<div className={style.onion}>
			<form onSubmit={handleAddURL} className={style.add}>
				<Input
					inputType={'text'}
					inputValue={url}
					inputPlaceholder={'onion url'}
					setInputValue={setUrl}
					exclusionSymbols={'/'}
				/>

				<Btn type='submit' text={TEXT.researcher_tg_btn_add} />
			</form>

			<div className={style.table}>
				{/* <RefreshBtn handle={loadData} /> */}
				{/* <Btn
					text={loading ? 'Оновлюю...' : 'Оновити список'}
					handle={loadData}
				/> */}

				<div style={{ marginTop: 20 }}>
					{files.length === 0 ? (
						<div>Немає активних завантажень</div>
					) : (
						<table>
							<thead>
								<tr>
									<th className={style.th}>Імʼя файлу</th>
									<th className={style.th}>Дата</th>
									<th className={style.th}>Статус</th>
									<th className={style.th}>Скачано</th>
									<th className={style.th}>Керування</th>
								</tr>
							</thead>
							<tbody>
								{files.length > 0 &&
									files.map((item, i) => (
										<tr key={i}>
											<td className={style.td}>{item.file_name}</td>
											<td className={style.td}>{item.post_date}</td>
											<td className={style.td}>
												{item.is_deleted ? 'deleted' : item.aria_status}
											</td>
											<td className={style.td}>
												{`${(item.aria_completed_length / 1024 / 1024).toFixed(
													2,
												)} з ${(item.aria_total_length / 1024 / 1024).toFixed(
													2,
												)} Mb`}
											</td>
											<td className={style.td}>
												<div>
													{item.is_deleted ? (
														<IgnoreIcon />
													) : (
														<>
															{['active', 'downloading'].includes(
																item.aria_status,
															) && (
																<PauseBtn
																	handle={handlePause}
																	value={item.aria_gid}
																/>
															)}
															{item.aria_status === 'paused' && (
																<UnpauseBtn
																	handle={handleUnpause}
																	value={item.aria_gid}
																/>
															)}
															{item.aria_status === 'error' && (
																<RetryBtn
																	handle={handleRetry}
																	value={item.aria_gid}
																/>
															)}
															{item.aria_status !== 'complete' && (
																<DeleteBtn
																	handle={handleRemoveFileInfo}
																	value={item}
																/>
															)}
															{item.aria_status === 'complete' && (
																<DownloadBtn
																	type={
																		item.is_inspector_take_original
																			? 'downloaded'
																			: ''
																	}
																	handle={() => handleDownload(item)}
																/>
															)}
														</>
													)}
												</div>
											</td>
										</tr>
									))}
							</tbody>
						</table>
					)}
				</div>
			</div>

			{isProgressing && <UploadProgressModal progress={progress} />}

			{isLoader && <Loader />}
			{alertText.length > 0 && (
				<CustomAlert message={alertText} onClose={() => setAlertText('')} />
			)}
		</div>
	)
}
